import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import styled from 'styled-components';

import FormattedCurrency from '@/components/Formatted/FormattedCurrency';
import { useAppSelector } from '@/redux/hooks';
import { getCatalogBuyersPremium, getCatalogCurrency } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { NewAccountWalkthroughSteps } from '@/types/walkthroughs';

import DescriptionSection from '../ItemDescription/DescriptionSection';

type Props = {
    catalogId: number;
    /** Add walkthrough DOM node */
    walkthrough?: boolean;
};

const BuyersPremium = ({ catalogId, walkthrough }: Props) => {
    const { high, low, lowCutoff, middle, middleCutoff } = useAppSelector((state) =>
        getCatalogBuyersPremium(state, catalogId)
    );

    const currency = useAppSelector((state) => getCatalogCurrency(state, catalogId));

    return (
        <StyledDescriptionSection
            body={
                <StyledBuyersPremium>
                    {Boolean(!(low && lowCutoff) && !middle && !high) && (
                        <StyledPremium>
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.lowPercentage"
                                values={{ low }}
                            />
                        </StyledPremium>
                    )}
                    {Boolean(low && lowCutoff) && (
                        <StyledPremium>
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.lowCutOff"
                                values={{ low }}
                            />{' '}
                            <FormattedCurrency
                                convert
                                sourceCurrency={currency}
                                value={lowCutoff}
                            />
                        </StyledPremium>
                    )}
                    {Boolean(middle && middleCutoff) && (
                        <StyledPremium>
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.middleCutOff"
                                values={{ middle }}
                            />{' '}
                            <FormattedCurrency
                                convert
                                sourceCurrency={currency}
                                value={middleCutoff}
                            />
                        </StyledPremium>
                    )}
                    {Boolean(middle && !middleCutoff) && (
                        <StyledPremium>
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.middleLowCutOff"
                                values={{ middle }}
                            />{' '}
                            <FormattedCurrency
                                convert
                                sourceCurrency={currency}
                                value={lowCutoff}
                            />
                        </StyledPremium>
                    )}
                    {Boolean(high) && (
                        <StyledPremium>
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.highCutOff"
                                values={{ high }}
                            />{' '}
                            <FormattedCurrency
                                convert
                                sourceCurrency={currency}
                                value={middleCutoff}
                            />
                        </StyledPremium>
                    )}
                </StyledBuyersPremium>
            }
            header="bidding_console.console.currentLiveItem.headers.buyersPremium"
            walkthroughStep={walkthrough ? NewAccountWalkthroughSteps.Item5 : undefined}
        />
    );
};

export default BuyersPremium;

const StyledDescriptionSection = styled(DescriptionSection)`
    && {
        margin-bottom: 32px;
    }
`;

const StyledBuyersPremium = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;

    @media print {
        margin: 0.5em 0 !important;
    }
`;

const StyledPremium = styled.li`
    display: flex;
    & > div {
        margin-left: 6px;
    }
`;
